const ProgressBar = ({ progress, showPercentage = true }) => (
  <div className="space-y-3">
    <div className="w-full bg-secondary rounded-full h-2 overflow-hidden">
      <div
        className="bg-primary h-2 rounded-full transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
    {showPercentage && (
      <p className="text-sm text-muted-foreground text-right font-medium">{Math.round(progress)}% complete</p>
    )}
  </div>
);

export default ProgressBar;
